import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/src/app/[locale]/legal/reembolsos/page.tsx");
